module.exports = __webpack_public_path__ + "static/media/logo-beneser-back.f7e524d6.svg";